import { ArrowRight, Building2, User } from "lucide-react";
import { ChoicePill, BillField } from "./parts";

// Step 2 of the quota pay flow: billing data for the donation declaration.
export function QuotaBillingForm({ bill, setBill, paying, amountEur, onSubmit, onCancel }) {
  return (
    <form onSubmit={onSubmit} className="mt-6 space-y-4 bg-white/8 backdrop-blur-sm border border-white/15 p-5" data-testid="quota-billing-form">
      <div className="overline text-white/80">Declaração de Donativo</div>
      <p className="text-xs text-white/75 leading-relaxed">
        Quer que a Declaração seja emitida em nome de:
      </p>
      <div className="grid grid-cols-2 gap-2">
        <ChoicePill
          active={bill.issue_to === "personal"}
          onClick={() => setBill({ ...bill, issue_to: "personal" })}
          Icon={User} label="Pessoa singular" testid="quota-issue-personal"
        />
        <ChoicePill
          active={bill.issue_to === "company"}
          onClick={() => setBill({ ...bill, issue_to: "company" })}
          Icon={Building2} label="Empresa" testid="quota-issue-company"
        />
      </div>

      {bill.issue_to === "personal" ? (
        <>
          <BillField label="Nome completo" value={bill.billing_name}
            onChange={(v) => setBill({ ...bill, billing_name: v })} testid="quota-bn" />
          <BillField label="NIF" value={bill.billing_nif}
            onChange={(v) => setBill({ ...bill, billing_nif: v })} testid="quota-nif" />
        </>
      ) : (
        <>
          <BillField required label="Nome da empresa" value={bill.billing_company}
            onChange={(v) => setBill({ ...bill, billing_company: v })} testid="quota-company" />
          <BillField label="NIF da empresa" value={bill.billing_company_nif}
            onChange={(v) => setBill({ ...bill, billing_company_nif: v })} testid="quota-cnif" />
        </>
      )}
      <BillField label="Morada fiscal" value={bill.billing_address}
        onChange={(v) => setBill({ ...bill, billing_address: v })} testid="quota-addr" />

      <div className="flex flex-wrap gap-2 pt-1">
        <button
          type="submit" disabled={paying}
          className="inline-flex items-center gap-2 px-5 py-3 bg-[hsl(var(--accent))] text-[#1A201F] text-xs uppercase tracking-[0.2em] font-semibold hover:bg-[#B3922E] transition-colors disabled:opacity-60"
          data-testid="quota-confirm-and-pay"
        >
          {paying ? "A processar…" : `Confirmar e pagar ${Number(amountEur).toFixed(0)} €`}
          <ArrowRight className="h-3.5 w-3.5" />
        </button>
        <button
          type="button" onClick={onCancel}
          className="px-4 py-3 text-xs uppercase tracking-[0.2em] text-white/75 hover:text-white"
          data-testid="quota-cancel-billing"
        >
          Cancelar
        </button>
      </div>
      <p className="text-[11px] text-white/65">
        Pode deixar os dados em branco se não precisar de Declaração. Saltamos diretamente para o pagamento.
      </p>
    </form>
  );
}
